import React from 'react';
import {SingleBehindTheScenes} from 'data/videoProductPage';
import * as styles from './BehindTheScenes.css';
import {ImageWithBlur} from '~/components/common/ImageWithBlur/ImageWithBlur';

export const SingleBehindTheScene = ({behindTheScene}: { behindTheScene: SingleBehindTheScenes }) => {
    return (
        <div className={styles.singleBehindTheScene}>
            <div className={styles.singleBehindTheSceneTitle}>
                <div className={styles.singleBehindTheSceneImgBlock}>
                    <div className={styles.imageContainer}>
                        <ImageWithBlur src={behindTheScene.iconUrl} alt={'icon'} layout={'fill'}/>
                    </div>
                </div>
                <div className={styles.singleBehindTheSceneTitleText}>
                    {behindTheScene.title}
                </div>
            </div>
            <div className={styles.singleBehindTheSceneText}>
                {behindTheScene.textContent}
            </div>
        </div>
    );
};
